import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const colors = constants.colors;

const black = colors.ui.black[500];
const coreBlue500 = colors.ui.core[500];
const neutral400 = colors.ui.neutral[400];
const neutral700 = colors.ui.neutral[700];
const white = colors.ui.white[500];

export const containerStylesCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  padding: "16px",
  backgroundColor: white,

  "@media print": {
    padding: "16px",
    gap: "16px",
  },
};

export const wordSectionCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  padding: "0 7px",
  gap: "8px",
};

export const targetWordAndArmsCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  position: "relative",
};

const armContainerCss: CSSObject = {
  position: "relative",
  flex: 1,
  display: "flex",
  alignItems: "flex-end",
  top: "20px",

  "@media print": {
    top: "30px",
  },
};

export const leftArmContainerCss: CSSObject = {
  ...armContainerCss,
  justifyContent: "flex-end",
};

export const rightArmContainerCss: CSSObject = {
  ...armContainerCss,
  justifyContent: "flex-start",
};

export const arrowSvgCss: CSSObject = {
  color: coreBlue500,
};

export const arrowLineSvgCss: CSSObject = {
  width: `calc(100% - 242px / 2)`,
  height: "72px",
  ...arrowSvgCss,
};

export const wordAndArrowContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const textAreaContainerCss: CSSObject = {
  ...typographyStyles.textMObj,
  width: "100%",
  height: "88px",
  padding: "7px 14px",
  border: `4px solid ${coreBlue500}`,
  borderRadius: "32px",
  color: neutral700,
  backgroundColor: white,
  display: "flex",
  flexDirection: "column",
};

export const targetWordContainerCss: CSSObject = {
  ...textAreaContainerCss,
  width: "266px",
  alignItems: "center",
};

export const wordContainerCss: CSSObject = {
  ...textAreaContainerCss,
  alignItems: "flex-start",
  width: "266px",
};

export const wordHeaderStylesCss: CSSObject = {
  ...typographyStyles.heading5Obj,
  fontWeight: 700,
  marginBottom: "4px",
};

export const wordInputStylesCss: CSSObject = {
  ...typographyStyles.textMObj,
  width: "100%",
  height: "100%",
  resize: "none",
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  backgroundColor: "transparent",
  fontWeight: "normal",

  "@media print": {
    wordBreak: "break-word",
    overflowWrap: "break-word",
    fontSize: "inherit !important",
  },
};

export const wordComponentsGridCss: CSSObject = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 266px)",
  justifyItems: "center",
  justifyContent: "space-between",

  "@media print": {
    justifyItems: "center",
    justifyContent: "space-between",
  },
};

export const wordComponentRowCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  width: "100%",
};

export const wordComponentLabelCss: CSSObject = {
  ...typographyStyles.textSObj,
  color: black,
  fontWeight: 600,
  letterSpacing: "0.5px",
  whiteSpace: "nowrap",
};

export const wordComponentInputCss: CSSObject = {
  ...typographyStyles.textSObj,
  width: "100%",
  margin: "0",
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  fontWeight: "normal",
  textAlign: "left",

  "&:disabled": {
    color: "inherit",
  },

  "@media print": {
    wordBreak: "break-word",
    overflowWrap: "break-word",
    fontSize: "inherit !important",
  },
};

export const wordComponentMeaningRowCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  width: "100%",
  marginTop: 4,
};

export const exampleTextAreaContainerCss: CSSObject = {
  ...textAreaContainerCss,
};

export const exampleLabelCss: CSSObject = {
  ...typographyStyles.textMObj,
  color: black,
  fontWeight: 600,
  whiteSpace: "nowrap",
};

export const exampleTextareaCss: CSSObject = {
  ...typographyStyles.textMObj,
  width: "100%",
  minHeight: "66px",
  padding: "8px",
  border: `1px solid ${neutral400}`,
  borderRadius: "6px",
  color: neutral700,
  backgroundColor: white,
  resize: "none",

  "@media print": {
    wordBreak: "break-word",
    overflowWrap: "break-word",
    fontSize: "inherit !important",
  },
};
